import rightArrowIcon from "../../icons/arrows/right.svg";
import React from "react";
import { useTranslation } from "react-i18next";
interface IBreadCrumbItem {
  label: string;
  onClick?: () => void;
  icon?: string;
  show?: boolean;
}

export interface IBreadCrumbsProps {
  items: IBreadCrumbItem[];
}

// const inlineStyles = {
//   container: {
//     display: "flex",
//     alignItems: "center",
//     gap: "10px",
//   },
//   item: {
//     display: "flex",
//     alignItems: "center",
//     color: "#414651",
//     fontWeight: 600,
//     fontSize: "14px",
//   },
//   pointer: {
//     cursor: "pointer",
//   },
// };

function BreadCrumbs(props: IBreadCrumbsProps) {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  return (
    <div className="flex items-center gap-2.5">
      {props.items.map((item, index) => {
        if (item.show === false) return null;

        return (
          <React.Fragment key={index}>
            {index > 0 && (
              <img
                src={rightArrowIcon}
                alt="right-arrow"
                className={`${isRTL ? "rotate-180" : ""}`}
              />
            )}
            <div className="flex items-center text-utilityGray-700 font-medium text-sm">
              {item.icon ? (
                <img
                  src={item.icon}
                  alt={item.label}
                  onClick={item.onClick}
                  className="cursor-pointer"
                />
              ) : (
                <span onClick={item.onClick} className="cursor-pointer">
                  {item.label}
                </span>
              )}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default BreadCrumbs;
